export default __webpack_public_path__ + "static/media/college-logo.86c2ec97.png";